import { Colors } from '../../config'
import { AbstractBlock } from './AbstractBlock'

export class FloatingBlock extends AbstractBlock {
  constructor (block, prev = null, next = null) {
    block.type = 'floating'
    if (!('kind' in block)) {
      block.kind = 'job'
    }
    super(block, prev, next)
  }

  /**
   *
   * @param i
   * @param id
   * @returns {Array}
   */
  getCells (i, id) {
    let ret = []
    if (this.startup) {
      ret.push({
        beginTime: +this.start,
        endTime: +this.start + +this.startup,
        style: {
          'background': this.dimColor
        },
        part: `Startup`,
        id,
        i
      })
    }
    ret.push({
      beginTime: +this.start + +this.startup,
      endTime: +this.start + +this.startup + +this.time,
      style: {
        'background': this.color
      },
      client: this.client,
      part: this.id + '-' + id,
      desc: this.part === 'idle' ? 'Idle (Floating)' : (this.part || ''),
      description: this.description || '',
      id,
      die: this.die,
      bom: (this.bom ? this.bom + (this.job ? '/' + (this.job + (this.customLabel ? '-' + this.customLabel : '')) : '') : ''),
      i
    })
    if (this.shutdown) {
      ret.push({
        beginTime: +this.start + +this.startup + +this.time,
        endTime: +this.start + +this.startup + +this.time + +this.shutdown,
        style: {
          'background': this.dimColor
        },
        part: `Shutdown`,
        id,
        i
      })
    }
    return ret
  }

  /**
   *
   * @param block
   */
  prepend (block) {
    if (this._prev) {
      throw new Error('Can only prepend to a head block!')
    }

    if (this.start > block.end) {
      block.linkNext(new FloatingIdleBlock(block.end, this.start - block.end, block, this))
    } else {
      this.start = block.end
      block.linkNext(this)
    }
  }

  /**
   *
   * @param block
   */
  append (block) {
    if (block.start === this.end) {
      block.link(this, this._next)
    } else if (block.start > this.end) {
      const tmp = this._next
      const idle = new FloatingIdleBlock(this.end, block.start - this.end, this, block)
      this.linkNext(idle)
      block.link(this._next, tmp)
      if (block.isOutage) {
        idle.remove()
      }
    } else if (block.start === this.start) {
      block.link(this._prev, this)
    } else {
      this.resolve(block)
    }

    this.bubbleNext()
  }

  /**
   *
   * @param block
   */
  resolve (block) {
    let rest = new FloatingBlock(this.obj, block, this._next)
    rest.start = block.end
    rest.time = this.end - block.start
    this.time -= rest.time
    block.link(this, rest)
  }

  bubbleNext () {
    if (this._prev) {
      this.start = this._prev.end
    }

    super.bubbleNext()
  }

  /**
   *
   * @param time
   */
  pull (time) {
    if (!this._prev || this._prev.type !== 'fixed') {
      this.start = time
      if (this._next) {
        this._next.pull(this.end)
      }
      return
    }

    let delta = Math.min(this.start - time, this.time)
    let insert = this._prev
    while (insert._prev && insert._prev.type === 'fixed' && insert._prev.end >= time) {
      insert = insert._prev
    }

    if (!insert._prev) {
      this.start = insert.end

      if (this._next) {
        this._next.pull(this.end)
      }
    } else {
      const start = insert._prev.end
      let prev = new FloatingBlock(this.obj, insert._prev, insert)
      prev.start = start
      prev.time = delta

      if (delta === this.time) {
        this.remove()
        if (insert._next) {
          insert._next.pull(prev.end)
        }
      } else {
        this.time -= delta
        this.start = insert.end

        if (this._next) {
          this._next.pull(this.end)
        }
      }
    }
  }
}

export class FloatingIdleBlock extends FloatingBlock {
  constructor (start, time, prev = null, next = null) {
    super({
      id: 'IDLE',
      kind: 'idle',
      part: 'idle',
      die: null,
      color: Colors.floatingIdle,
      startup: 0,
      shutdown: 0,
      start,
      time
    }, prev, next)
  }

  getCells (i, id) {
    return [{
      beginTime: +this.start,
      endTime: +this.start + +this.time,
      style: {
        'background': this.color
      },
      part: this.id + '-' + id,
      desc: 'Idle (Floating)',
      description: '',
      id,
      die: this.die,
      bom: '',
      i
    }]
  }
}
